/**
 * This file contains many functions that make various calls to our
 * location API endpoint and return the promises from those calls.
 */
import queryString from 'querystring';
import Api from '../api.ts';

const LOCATION = '/locations';

const LocationAPI = {
  getOne(locationId) {
    return Api.get(`${LOCATION}/${locationId}`);
  },

  get(options = {}) {
    return Api.get(`${LOCATION}?${queryString.encode(options)}`);
  },

  create(location) {
    const data = { location };
    return Api.post(`${LOCATION}`, { data });
  },

  update(locationId, location) {
    const data = { location };
    return Api.put(`${LOCATION}/${locationId}`, { data });
  },

  remove(locationId) {
    return Api.delete(`${LOCATION}/${locationId}`);
  },

  createLocationHour(locationId, hour) {
    const data = { hour };
    return Api.post(`${LOCATION}/${locationId}/hours`, { data });
  },

  getLocationHour(locationId, hourId) {
    return Api.get(`${LOCATION}/${locationId}/hours/${hourId}`);
  },

  updateLocationHour(locationId, hourId, hour) {
    const data = { hour };
    return Api.put(`${LOCATION}/${locationId}/hours/${hourId}`, { data });
  },

  deleteLocationHour(locationId, hourId) {
    return Api.delete(`${LOCATION}/${locationId}/hours/${hourId}`);
  },
};

export default LocationAPI;
